module.exports = "/_next/static/images/icon-market-buy-325a1cff8431cc615b0a23ca518acedb.svg";